// @ts-nocheck

/**
 * * `male` - male
 * `female` - female
 * `other` - other
 */
export type Gender881Enum = typeof Gender881Enum[keyof typeof Gender881Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender881Enum = {
  male: "male",
  female: "female",
  other: "other",
} as const;
